<template xmlns:https="http://www.w3.org/1999/xhtml">
    <div class="polyamid">
        <img
            src="@/assets/img/reaktionen/polyamid.png"
            alt="Polykondensation"
            title="Polykondensation"
            width="100%"
        />
        <small
            ><a
                href="https://www.lernhelfer.de/schuelerlexikon/chemie-abitur/artikel/polykondensation"
                target="_blank"
                >Quelle</a
            ></small
        >
    </div>
</template>

<script>
export default {
    name: 'polyamid',
};
</script>
